import axios from "axios";
import encrypt from '../utils/crypto-util';
import Errormonitoring from '@/error_watch/errorHandler'

//导入pinia
import { useNewpageData } from "../stroe/pinia";
/**
 * 导入firebase 监听函数
 */
import { logEventAnalytics } from '@/Firebase/firebase';
axios.defaults.baseURL = 'https://api.game.iglees.com'
axios.defaults.timeout = 10000
let aecdata: any
let md5: any
let md51: any
// 进行加密处理
// 获取随机数
let Randomnum
function getUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
getUuid();
// 获取签名 
let hedata = () => {
    if (localStorage.getItem('usetoken')) {
        return { 'h_token': localStorage.getItem('usetoken') }
    }
}
hedata()
// 保存发送数据
let Savedata: any
//保存接口
let Saveurl: any
// 请求拦截器，响应拦截器
// 添加请求拦截器
axios.interceptors.request.use(function (config: any) {
    // 赋值
    Savedata = config.data
    Saveurl = config.url
    // console.log(Saveurl,'请求url');
    // 获取时间戳 
    let time: any = new Date().getTime()
    Randomnum = getUuid()
    console.log(config.url, '请求信息');
    if (localStorage.getItem('Pfdlanguage')) {
        if (localStorage.getItem('Pfdlanguage')?.includes('zh')) {
            config.url = config.url + '?lang=zh-cn'
        } else if (localStorage.getItem('Pfdlanguage')?.includes('en')) {
            config.url = config.url + '?lang=en-us'
        } else {
            config.url = config.url + '?lang=en-us'
        }
    }
    // aec加密数据
    if (config.data) {
        aecdata = encrypt.aesEncrypty(config.data)
        if (config.ablen == 1) {
        } else {
            config.data = aecdata
        }
    }
    let data1 = `sign:data=${aecdata}&nonceStr=${Randomnum}&timestamp=${time}`
    let data2 = `sign:data=&nonceStr=${Randomnum}&timestamp=${time}`
    // 获取MD5加密数据
    md5 = encrypt.md5(config.data ? data1 : data2)
    md51 = encrypt.md5(data2)
    config.headers = {
        ...config.headers,
        'Content-Type': 'text/plain',
        'h_timestamp': time,
        'h_nonceStr': Randomnum,
        'h_sign': config.ablen == 1 ? md51 : md5,
        'h_token': localStorage.getItem('usetoken') ? localStorage.getItem('usetoken') : '',
    }
    // 在发送请求之前做些什么  
    return config;
}, function (error) {
    console.error('请求报错', error);
    let obj = {
        errorSend: encrypt.aesDecrypt(error.config.data),
        errorurl: error.config.url,
        error: error
    }
    Errormonitoring.onerror(obj)
    // 对请求错误做些什么
    return Promise.reject(error);
});
// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    //实例化pinia
    const NewpageData = useNewpageData();
    let data = JSON.parse(encrypt.aesDecrypt(response.data))
    if (data.code == 105) {
        console.log(data);
        // 105 token失效 执行登录状态清除
        NewpageData.Settokenblen(false)
    } else {
        NewpageData.Settokenblen(true)
    }
    if (data.code !== 0) {
        // 上报
        logEventAnalytics("e_request_failed", {
            code: data.code,
            erromessge: data.msg,
        })
    }
    if (data.status !== 1) {





        console.error('返回值不对', encrypt.aesDecrypt(response.data));
        let obj = {
            errorSend: Savedata,
            errorurl: Saveurl,
            error: 'status !== 1'
        }
        Errormonitoring.onerror(obj)
    }
    return JSON.parse(encrypt.aesDecrypt(response.data))
}, function (error) {
    let obj = {
        errorSend: encrypt.aesDecrypt(error.config.data),
        errorurl: error.config.url,
        error: error
    }
    console.error('接收报错', error);
    Errormonitoring.onerror(obj)
    // console.error(error,'返回报错',encrypt.aesDecrypt(error.config.data),'发送数值');
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    return Promise.reject(error);
});
declare module 'axios' {
    interface AxiosInstance {
        (config: AxiosRequestConfig): Promise<any>
    }
}
export default axios
